module.exports = __webpack_public_path__ + "static/media/img-card (5).74a3598f.jpg";